// extracted by mini-css-extract-plugin
export default {"content":"Paper-index__content--bW5WI","isTransparent":"Paper-index__isTransparent--NcSrG","isCondensed":"Paper-index__isCondensed--NMcH3"};